<template>
  <v-text-field
    :model-value="industry"
    :label="$t('product-finder.industry-placeholder')"
    hide-details
    :disabled="disabled"
    variant="outlined"
    color="primary"
    @click="onIndustryClick()"
    @update:model-value="onInput"
  />
</template>

<script>
import { debounce } from '@/lib/debounce'

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      industry: this.value,
      debouncedEmit: null,
    }
  },
  created() {
    this.debouncedEmit = debounce(this.emitInput, 2000)
  },
  methods: {
    emitInput(value) {
      this.$emit('input', value)
    },
    onInput(value) {
      this.debouncedEmit(value)
    },
    onIndustryClick() {
      this.$tracking.event('Account Creation', 'Clicked', 'Industry input clicked')
    },
  },
  emits: ['input'],
}
</script>
